import * as React from 'react'
import { useEffect, useState } from 'react'

import { getOpportunityStatus } from '@user/components/Opportunities/DetailPage/utils'
import { IOpportunityDetail } from '@user/store/opportunity/typings'
import { ISalesFunnelStage } from '@user/store/salesFunnel/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'
import { OpportunityProgressWidget } from '@user/components/Opportunities/OpportunityCard/OpportunityProgressWidget/OpportunityProgressWidget'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Theme } from '@mui/material/styles'

interface Props {
  detail: IOpportunityDetail
  salesFunnelStages: ISalesFunnelStage[]
  status: OPPORTUNITY_STATUSES
  disabled: boolean
}

export function OpportunityProgress(props: Props) {
  const { detail, salesFunnelStages, disabled } = props
  const [percentage, setPercentage] = useState<number | null>()

  useEffect(() => {
    if (!!salesFunnelStages) {
      const result = getOpportunityStatus(
        salesFunnelStages,
        detail.salesFunnelStageId,
      )
      setPercentage(result.percentage)
    }
  }, [detail, salesFunnelStages])

  return (
    <Stack p={2}>
      <Typography
        variant="h6"
        color={(theme: Theme) => theme.palette.text.primary}
        mb={3}
      >
        {percentage
          ? `Opportunity is ${percentage}% Completed to Close`
          : 'Opportunity Status'}
      </Typography>
      <OpportunityProgressWidget
        opportunityId={detail.id}
        funnelStageId={detail.salesFunnelStageId}
        salesFunnelId={detail.salesFunnelId}
        disabled={disabled}
      />
    </Stack>
  )
}
